import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MarketTicker from "./components/MarketTicker";
import HomePage from "./pages/HomePage";
import VaultPage from "./pages/VaultPage";
import WelcomePage from "./pages/WelcomePage";
import IndemnityPage from "./pages/IndemnityPage";
import IngestionPage from "./pages/IngestionPage";
import RosterPage from "./pages/RosterPage";
import MetadataAuditPage from "./pages/MetadataAuditPage";
import SplitSheetPage from "./pages/SplitSheetPage";
import CatalogPage from "./pages/CatalogPage";
import AboutPage from "./pages/AboutPage";
import AboutLeaverHallPage from "./pages/AboutLeaverHallPage";
import LicensingPage from "./pages/LicensingPage";
import RoyaltySetupPage from "./pages/RoyaltySetupPage";
import IntakePage from "./pages/IntakePage";
import AnalyticsPage from "./pages/AnalyticsPage";
import LinkGeneratorPage from "./pages/LinkGeneratorPage";
import AdminPage from "./pages/AdminPage";
import CorporateUpdatesPage from "./pages/CorporateUpdatesPage";
import BriefsPage from "./pages/BriefsPage";
import FAQPage from "./pages/FAQPage";
import trackingService from "./services/trackingService";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Track page navigation
    trackingService.track('page_navigation', {
      path: pathname,
      timestamp: new Date().toISOString(),
      referrer: document.referrer
    });
  }, [pathname]);

  return null;
};

// Layout wrapper to conditionally show header/footer/ticker
const Layout = ({ children }) => {
  const location = useLocation();
  const standalonePages = ['/welcome', '/clearance', '/ingestion', '/audit', '/split-sheet', '/royalty-setup', '/intake', '/admin/analytics', '/admin/link-generator', '/admin/briefs'];
  const isStandalonePage = standalonePages.includes(location.pathname);
  
  return (
    <>
      {!isStandalonePage && <Header />}
      {children}
      {!isStandalonePage && <Footer />}
      {!isStandalonePage && <MarketTicker />}
    </>
  );
};

function App() {
  // Initialize tracking service when app loads
  useEffect(() => {
    // Initialize the surveillance perimeter
    trackingService.initialize();
    
    // Check for email link clicks (executive identification)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('source') === 'email' || document.referrer.includes('email')) {
      trackingService.trackEmailLinkClick('email_campaign');
    }
    
    // Retry any failed tracking events
    trackingService.retryFailedEvents();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/about-leaver-hall" element={<AboutLeaverHallPage />} />
            <Route path="/leaver-hall" element={<AboutLeaverHallPage />} />
            <Route path="/licensing" element={<LicensingPage />} />
            <Route path="/vault" element={<VaultPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/clearance" element={<IndemnityPage />} />
            <Route path="/ingestion" element={<IngestionPage />} />
            <Route path="/roster" element={<RosterPage />} />
            <Route path="/audit" element={<MetadataAuditPage />} />
            <Route path="/split-sheet" element={<SplitSheetPage />} />
            <Route path="/royalty-setup" element={<RoyaltySetupPage />} />
            <Route path="/intake" element={<IntakePage />} />
            <Route path="/admin/analytics" element={<AnalyticsPage />} />
            <Route path="/admin/link-generator" element={<LinkGeneratorPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/corporate-updates" element={<CorporateUpdatesPage />} />
            <Route path="/admin/briefs" element={<BriefsPage />} />
            <Route path="/faq" element={<FAQPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
